<template>
	<el-dialog width="900px" :visible.sync="visible" title="个人用户列表" :close-on-click-modal="false" :close-on-press-escape="false">
	  <el-card shadow="never" class="aui-card--fill">
		<div class="mod-plat__platinfouser}">
		  <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
			  <el-form-item style="margin-bottom:10px;">
			    <el-input v-model="dataForm.realName" placeholder="姓名" clearable></el-input>
			  </el-form-item>
			  <el-form-item style="margin-bottom:10px;">
			    <el-input v-model="dataForm.phone" placeholder="手机号" clearable></el-input>
			  </el-form-item>
			<el-form-item style="margin-bottom:10px;">
			  <el-input v-model="dataForm.idCard" placeholder="身份证" clearable></el-input>
			</el-form-item>
			<el-form-item style="margin-bottom:10px;">
			  <el-input v-model="dataForm.payerAccountTitle" placeholder="历史交易发布方" clearable></el-input>
			</el-form-item>
			<el-form-item style="margin-bottom:10px;">
			  <el-select v-model="dataForm.businessItem" @input="$emit('input', $event)" placeholder="经营项目" clearable filterable @change="handleChange">
					<el-option :label="data.dictLabel" v-for="data in selectList" :key="data.dictLabel" :value="data.dictLabel"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
			  <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
			</el-form-item>
		  </el-form>
		  <div class="checkUser" v-if="userList.length > 0">已勾选：

		  	<el-tag v-for="(item,index) in userList" closable type="" @close="fnClose(item)" :key="index">{{item.realName}}</el-tag>
		 	<!-- <span v-for="(item,index) in userList">{{item}}</span>  -->
		  </div>
		  <el-table ref="multipleTable" v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" :row-key="getRowKey" style="width: 100%;">
			<el-table-column type="selection" header-align="center" align="center" :reserve-selection="true" width="50"></el-table-column>
			<el-table-column label="序号" type="index" width="50" align="center">
			  <template slot-scope="scope">
				<span>{{(page - 1) * limit + scope.$index + 1}}</span>
			  </template>
			</el-table-column>
			<el-table-column prop="realName" label="姓名" header-align="center" align="center"></el-table-column>
			<el-table-column prop="idCard" label="身份证号" header-align="center" align="center"></el-table-column>
			<el-table-column prop="phone" label="手机号" header-align="center" align="center"></el-table-column>
			<el-table-column prop="businessItem" label="经营项目" header-align="center" align="center"></el-table-column>

		  </el-table>
		  <el-pagination
          style="position: relative;padding-top: 15px;text-align: left;bottom:0"
		  background
			:current-page="page"
			:page-sizes="[10, 20, 50, 100]"
			:page-size="limit"
			:total="total"
			layout="total, sizes, prev, pager, next, jumper"
			@size-change="pageSizeChangeHandle"
			@current-change="pageCurrentChangeHandle">
		  </el-pagination>
		</div>
	  </el-card>
	  <template slot="footer">
	    <el-button  v-no-more-click @click="visible = false">{{ $t('cancel') }}</el-button>
	    <el-button v-no-more-click type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
	  </template>
  </el-dialog>
</template>

<script>
import { getDictDataList } from '@/utils'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
		userList:'',
	 	selectList:getDictDataList('businessItems'),
      mixinViewModuleOptions: {
        getDataListURL: '/sys/plat/info/user/realNameUsablePage',
        getDataListIsPage: true,
        deleteURL: '/sys/plat/info/user',
        deleteIsBatch: true
      },
	  id: 0,
	  visible: false,
      dataForm: {
        id: '',
        idCard: '',
        realName: '',
        phone: '',
		businessItem:'',
		payerAccountTitle:''
      },
	  ids: []
    }
  },
  methods: {
	getRowKey(row) {
      return row.id;
    },
	  init () {
		this.ids = []
		this.dataForm.realName = '';
		this.dataForm.phone = '';
		this.dataForm.idCard = '';
		this.dataForm.payerAccountTitle = '';
		this.dataForm.businessItem = '',
		this.getDataList()
	    this.visible = true
		if(this.$refs.multipleTable){
			this.$refs.multipleTable.clearSelection()
		}
	  },
	  handleChange(e){
		  this.dataForm.businessItem = e;
	  },
	  dataListSelectionChangeHandle (val) {
		  let userList =  [];
		val.map((item,index) => {
			userList.push(item)
		})
		this.userList = userList;
		  let ids = []
		  for (let i = 0; i < val.length; i++) {
			  ids.push(val[i].userId)
		  }
		  this.ids = ids
	  },
	  dataFormSubmitHandle () {
		  if(this.ids.length == 0){
			  return this.$message.error("请选择人员");
		  }
		  this.$http.post('/sys/plat/task/assign', { taskId: this.id, userIdList: this.ids }).then(({ data: res }) => {
		      if (res.code !== 0) {
		          return this.$message.error(res.msg)
		      }
		      this.$message({
		          message: '分配成功',
		          type: 'success',
		          duration: 1000,
		          onClose: () => {
		  			this.visible = false
            this.$emit('refreshDataList')
		          }
		      })
		  }).catch(() => {
		  })
	  },
	//   删除用户
	fnClose(obj){
		console.log(obj)
		let newArrUser = [];
		this.userList.map((item,index) => {
			if(obj.id == item.id){
				newArrUser.push(item)
			}
		})
		newArrUser.forEach(row => {
			this.$refs.multipleTable.toggleRowSelection(row);
		});
	}
  }
}
</script>
<style lang="scss">
.checkUser{
	padding-top: 10px;
	color:#188eee;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	span{
		// background: #55abf1;
		// color: #fff;
		// padding: 3px 10px;
		// border-radius: 10px;
		// margin-bottom: 5px;
		margin-right: 7px;
	}
}
</style>